<template>
  <v-container
    fluid
    class="justify-center d-flex align-center h-full"
  >
    <v-card
      border
      class="verification-card pa-5"
    >
      <v-card-title class="justify-center">
        {{ $t('labels.email-verification.title') }}
      </v-card-title>

      <div class="justify-center d-flex align-center">
        <div v-if="state === 'pending'">
          <p>
            <v-progress-circular
              :size="20"
              :width="2"
              indeterminate
              color="primary"
              class="mr-4"
              small
            />
            {{ $t('labels.email-verification.pending') }}
          </p>
        </div>

        <div v-if="state === 'verified'">
          <div class="justify-center mb-4 d-flex">
            <v-icon
              color="primary"
              :size="30"
            >
              mdi-check-circle-outline
            </v-icon>
          </div>
          <p class="text-center">
            {{ $t('labels.email-verification.verified') }}
          </p>
        </div>
        <div v-if="state === 'failed'">
          <div class="justify-center mb-4 d-flex">
            <v-icon
              color="error"
              :size="30"
            >
              mdi-alert-circle-outline
            </v-icon>
          </div>
          <p
            class="text-center"
            v-html="error"
          />
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import featureNames from '@/lib/featureNames'

import VERIFY_EMAIL_CHANGE_REQUEST from '../queries/VerifyEmailChangeRequest.gql'

export default {
  components: {},

  data() {
    return {
      state: 'pending',
      error: '',
      timeoutDisplay: null,
      timeoutLogout: null,
    }
  },

  async mounted() {
    // wait a bit to display the spinner
    this.timeoutDisplay = setTimeout(async () => {
      const {
        data: { verifyEmailChangeRequest },
      } = await this.verifyEmailById(this.$route.params.id)
      if (verifyEmailChangeRequest) {
        this.state = 'verified'
        this.timeoutLogout = setTimeout(() => {
          this.logout()
        }, 5000)
      }
    }, 2000)
  },

  unmounted() {
    clearTimeout(this.timeoutDisplay)
    clearTimeout(this.timeoutLogout)
  },

  methods: {
    logout() {
      this.$auth.logout()
    },
    async verifyEmailById(id) {
      try {
        return await this.$apollo.mutate({
          mutation: VERIFY_EMAIL_CHANGE_REQUEST,
          variables: {
            id,
          },
        })
      } catch (error) {
        this.error = this.$t('labels.email-verification.failed', {
          supportEmail: this.$features.feature(featureNames.SUPPORT_CONTACT).config.support.email,
        })
        this.state = 'failed'
      }
    },
  },
}
</script>

<style scoped>
.verification-card {
  width: 400px;
}
</style>
